import { useRef, useState } from "react";

function DockIcon({ app, mouseX, onClick }) {
  const ref = useRef(null);
  const [scale, setScale] = useState(1);
  const [hovered, setHovered] = useState(false);

  const handleMove = () => {
    if (!ref.current || mouseX.current == null) return;
    const rect = ref.current.getBoundingClientRect();
    const center = rect.left + rect.width / 2;
    const dist = Math.abs(mouseX.current - center);
    const s = Math.max(1, 1.6 - dist / 180);
    setScale(s);
  };

  return (
    <div className="relative flex flex-col items-center group">
      {hovered && (
        <div className="absolute -top-9 px-2.5 py-1 rounded-md bg-black/70 text-white text-xs whitespace-nowrap backdrop-blur-md border border-white/10">
          {app.label}
        </div>
      )}
      <button
        ref={ref}
        data-testid={`dock-${app.id}`}
        onClick={onClick}
        onMouseEnter={() => { setHovered(true); handleMove(); }}
        onMouseLeave={() => { setHovered(false); setScale(1); }}
        onMouseMove={handleMove}
        className="flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-2xl text-2xl md:text-[28px] border border-white/25 shadow-lg transition-transform duration-100 ease-out will-change-transform"
        style={{
          transform: `scale(${scale}) translateY(${-(scale - 1) * 14}px)`,
          background: app.bg || "rgba(255,255,255,0.18)",
          backdropFilter: "blur(12px)",
        }}
        aria-label={app.label}
      >
        {app.icon}
      </button>
      {app.active && <span className="w-1 h-1 rounded-full bg-white/80 mt-1" />}
    </div>
  );
}

export default function Dock({ apps, openWindows, onOpen }) {
  const mouseX = useRef(null);
  return (
    <div
      data-testid="dock"
      className="fixed bottom-2 left-1/2 -translate-x-1/2 z-[90] flex items-end gap-1.5 md:gap-2 px-2.5 md:px-3 pb-1.5 pt-2 rounded-2xl bg-white/15 border border-white/20 shadow-2xl max-w-[calc(100vw-16px)] overflow-x-auto mac-scroll"
      style={{ backdropFilter: "blur(20px)" }}
      onMouseMove={(e) => (mouseX.current = e.clientX)}
      onMouseLeave={() => (mouseX.current = null)}
    >
      {apps.map((app) =>
        app.divider ? (
          <div key={app.id} className="w-px h-10 md:h-12 bg-white/25 mx-1 self-center" />
        ) : (
          <DockIcon
            key={app.id}
            app={{ ...app, active: openWindows.includes(app.id) }}
            mouseX={mouseX}
            onClick={() => onOpen(app)}
          />
        )
      )}
    </div>
  );
}
